import React, { Fragment } from "react"
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/es/integration/react"
import { ToastContainer } from "react-toastify"

import { persistor, store } from "@redux"
import { KioskContainer, PrivateContainer } from "containers"
import { cdsRoutes, kioskRoutes, printRoutes, privateRoutes, publicRoutes } from "routes"
import { NewServiceWorkerModal, PrintListener } from "components"

const App = () => (
  <Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Switch>
            <Route
              exact
              path={publicRoutes.map(privateRoute => privateRoute.path)}
            >
              <Switch>
                {publicRoutes.map(publicRoute =>
                  <Route
                    key={publicRoute.path}
                    exact
                    path={publicRoute.path}
                    render={() => publicRoute.component}
                  />
                )}
              </Switch>
            </Route>
          </Switch>

          <Switch>
            <Route
              exact
              path={privateRoutes.map(privateRoute => privateRoute.path)}
            >
              <PrivateContainer>
                <Switch>
                  {privateRoutes.map(privateRoute =>
                    <Route
                      key={privateRoute.path}
                      exact
                      path={privateRoute.path}
                      render={() => privateRoute.component}
                    />
                  )}
                </Switch>
              </PrivateContainer>
            </Route>
          </Switch>

          <Switch>
            <Route
              exact
              path={printRoutes.map(privateRoute => privateRoute.path)}
            >
              <Switch>
                {printRoutes.map(printRoute =>
                  <Route
                    key={printRoute.path}
                    exact
                    path={printRoute.path}
                    render={() =>
                      printRoute.component
                    }
                  />
                )}
              </Switch>
            </Route>
          </Switch>

          <Switch>
            <Route
              exact
              path={kioskRoutes.map(kioskRoute => kioskRoute.path)}
            >
              <KioskContainer>
                <Switch>
                  {kioskRoutes.map(kioskRoute =>
                    <Route
                      key={kioskRoute.path}
                      exact
                      path={kioskRoute.path}
                      render={() => kioskRoute.component}
                    />
                  )}
                </Switch>
              </KioskContainer>
            </Route>
          </Switch>

          <Switch>
            <Route
              exact
              path={cdsRoutes.map(cdsRoute => cdsRoute.path)}
            >
              <Switch>
                {cdsRoutes.map(cdsRoute =>
                  <Route
                    key={cdsRoute.path}
                    exact
                    path={cdsRoute.path}
                    render={() => cdsRoute.component}
                  />
                )}
              </Switch>
            </Route>
          </Switch>

        </Router>

        <PrintListener />
      </PersistGate>
    </Provider>

    <ToastContainer closeOnClick rtl />

    <NewServiceWorkerModal />
  </Fragment>
)

export default App